import React from 'react'

const Footer = ({ showContactLink = false }) => {
  const contactEmail = 'info@sweetestadsmedia.com'
  const termsHref = 'https://sweetestadsmedia.com/terms-ofuse/?target=english'
  const privacyPolicyHref = 'https://sweetestadsmedia.com/privacy-policy?target=english'
  const contactSubject = 'Issues with Interactive Business'
  const contactBody = [
    'Hello Sweetest Ads Media team,',
    '',
    "I'm having issues with the Interactive Business software. Can I please receive some assistance?",
    '',
    '(Enter your name and best contact information)',
  ].join('\n')
  const contactHref = `mailto:${contactEmail}?subject=${encodeURIComponent(contactSubject)}&body=${encodeURIComponent(contactBody)}`

  return (
    <footer className="text-[#101828]">
      <div className="mx-auto flex w-full max-w-7xl flex-wrap items-center justify-between gap-4 border-t border-[#E4E7EC] px-4 pb-2 pt-5 lg:grid lg:grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)]">
        <nav aria-label="Legal" className="flex shrink-0 items-center gap-6 lg:justify-self-start">
          <a
            href={termsHref}
            target="_blank"
            rel="noreferrer"
            className="text-sm font-medium leading-5 text-[#FF1B54] outline-none focus-visible:underline"
          >
            Terms and Conditions
          </a>
          <a
            href={privacyPolicyHref}
            target="_blank"
            rel="noreferrer"
            className="text-sm font-medium leading-5 text-[#FF1B54] outline-none focus-visible:underline"
          >
            Privacy Policy
          </a>
        </nav>

        <div className="flex min-w-[280px] flex-1 items-center justify-center text-center text-[15px] leading-5 lg:min-w-0 lg:flex-none lg:justify-self-center">
          <span className="whitespace-nowrap font-medium text-[#101828]">© 2026. Interactive Business. All Rights Reserved</span>
        </div>

        <div className="flex shrink-0 items-center gap-[14px] lg:justify-self-end">
          {showContactLink ? (
            <a
              href={contactHref}
              className="text-sm font-semibold leading-5 text-[#FF1B54] outline-none focus-visible:underline"
            >
              Contact Us
            </a>
          ) : null}
          <span className="rounded-full border border-[#E4E7EC] bg-white px-2 py-1 text-[11px] font-medium leading-[14px] text-[#667085]">
            v0.3
          </span>
        </div>
      </div>
    </footer>
  )
}

export default Footer
